// ### Imports
// * Import lib
import React from "react";
import { CircularProgress, useTheme } from "@mui/material";
import LoadingImageLight from "../../../assets/images/LoadingImage.svg";
import LoadingImageDark from "../../../assets/images/dark_theme/LoadingImageDark.svg";
import { getThemeName } from "../../utils/utils";

// * Import kits
import Box from "../../kit/Box";
import { useSelector } from "react-redux";

export function Loader({
  message,
  showLoadingImage = true,
  showProgressCircle = true,
  loaderStyle = {},
  left = "50%",
  circleStyle = {},
  circleSize = "16px",
}) {
  const theme = useTheme();
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const LoadingImage = getThemeName(isDarkMode)
    ? LoadingImageDark
    : LoadingImageLight;
  const LoaderBoxStyle =
    Object.keys(loaderStyle).length > 0
      ? loaderStyle
      : {
          position: "absolute",
          left: left,
          top: "55%",
          WebkitTransform: "translate(-50%, -45%)",
          transform: "translate(-50%, -45%)",
          textAlign: "center",
        };
  return (
    <Box sx={LoaderBoxStyle}>
      {showLoadingImage && (
        <>
          <Box
            component="img"
            alt="Logo"
            sx={{ width: "40%" }}
            src={LoadingImage}
          />
          <br></br>
          <br></br>
        </>
      )}

      {showProgressCircle && (
        <CircularProgress size={circleSize} sx={circleStyle} />
      )}
      {message && (
        <div style={{ color: theme.palette.text.secondary }}>{message}</div>
      )}
    </Box>
  );
}

export default Loader;
